import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-90px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const scrollToId = (id) => {
  const target = document.getElementById(id);
  if (!target) return;
  if (window.__lenis) window.__lenis.scrollTo(target, { offset: -72, duration: 1.5 });
  else target.scrollIntoView({ behavior: "smooth" });
};

export const SectionTag = ({ children, color = "#1F5BFF", dark = false }) => (
  <div className="flex items-center gap-3 mb-6" data-testid={`section-tag-${String(children).toLowerCase().replace(/\s+/g, "-")}`}>
    <span className="h-[2px] w-10" style={{ background: color }} />
    <span className={`text-xs font-semibold tracking-[0.3em] uppercase ${dark ? "text-paper" : ""}`} style={{ color }}>
      {children}
    </span>
  </div>
);
